import React, { useCallback } from 'react';
import ListByDate from 'components/ListByDate';
import Card from 'components/Card';
import Offer from 'components/Offer';
import OfferActionsList from 'components/OfferActionsList';
import { useOffers } from 'hooks/useOffers/useOffers';
import Spinner from 'components/Spinner';
import AlertBar from 'components/AlertBar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';
import moment from 'moment-timezone';
import { SOURCES } from 'utils/constants/trackingSources';

const Offers = ({ className }) => {
  const { offers, error, loading } = useOffers();
  const { t } = useTranslation('Offers');
  let history = useHistory();

  const handleClick = useCallback(
    offerId => history.push(`${ROUTES.OFFER_DETAIL.DEFAULT}/${offerId}`, {
        source: SOURCES.OFFERS_LIST_PAGE_SOURCE
      }),
    [history]
  );

  const isBeforeNow = (date, tz) => {
    return moment().isAfter(moment(date).tz(tz), 'day');
  };

  const renderOffers = () => {
    if (loading) {
      return (
        <div className="offers__loading">
          <Spinner />
        </div>
      );
    }

    if (error) {
      return <div className="offers__alert">{t('error')}</div>;
    }

    const filteredOffers = offers.filter(
      offer => !isBeforeNow(offer.end_time_to, offer.end_time_to_tz)
    );

    if (!filteredOffers || filteredOffers.length === 0) {
      return <div className="offers__alert">{t('noOffers')}</div>;
    }

    return (
      <ListByDate
        items={filteredOffers}
        dateField="start_time_from"
        timeZoneField="start_time_from_tz"
      >
        {({ item }) => {
          const requestedOffer =
            item.requested &&
            item.acceptance_status &&
            item.acceptance_status.status === 'ACCEPTED';
          const alreadyBidOffer =
            item.acceptance_status && item.acceptance_status.status === 'BID';
          const biddableOffer = item.is_bidding_enabled;
          const offerAmount = item.acceptance_status
            ? item.acceptance_status.cost
            : item.net_full_cost;

          return (
            <Card handleClick={() => handleClick(item.offer_id)}>
              <Card.Body>
                <Offer
                  offer={item}
                  biddableOffer={biddableOffer}
                  offerAmount={offerAmount}
                />
              </Card.Body>
              <Card.Footer>
                <OfferActionsList
                  offerId={item.offer_id}
                  journeyId={item.id}
                  requested={requestedOffer}
                  alreadyBid={alreadyBidOffer}
                  biddableOffer={biddableOffer}
                />
              </Card.Footer>
            </Card>
          );
        }}
      </ListByDate>
    );
  };

  return (
    <>
      <AlertBar />
      <div className={className} data-testid="offers">
        <div className="offers">
          <div data-testid="offers__container" className="offers__container">
            {renderOffers()}
          </div>
        </div>
      </div>
    </>
  );
};

export default Offers;
